import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCalculatorAlt';
/** Renders an SVG icon. */
const SvgCalculatorAlt = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M13.707 21.707a1 1 0 0 0-1.414-1.414zm-5.414 2.586a1 1 0 1 0 1.414 1.414zm1.414-4a1 1 0 0 0-1.414 1.414zm2.586 5.414a1 1 0 0 0 1.414-1.414zM13 16a1 1 0 1 0 0-2zm-4-2a1 1 0 1 0 0 2zm3-1a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zm13 5a1 1 0 1 0 0-2zm-4-2a1 1 0 1 0 0 2zm4 6a1 1 0 1 0 0-2zm-4-2a1 1 0 1 0 0 2zm4-8a1 1 0 1 0 0-2zm-4-2a1 1 0 1 0 0 2zM8 4h16V2H8zm18 2v20h2V6zm-2 22H8v2h16zM6 26V6H4v20zm2 2a2 2 0 0 1-2-2H4a4 4 0 0 0 4 4zm18-2a2 2 0 0 1-2 2v2a4 4 0 0 0 4-4zM24 4a2 2 0 0 1 2 2h2a4 4 0 0 0-4-4zM8 2a4 4 0 0 0-4 4h2a2 2 0 0 1 2-2zm18 6H6v2h20zM12.293 20.293l-2 2 1.414 1.414 2-2zm-2 2-2 2 1.414 1.414 2-2zm1.414 0-2-2-1.414 1.414 2 2zm-1.414 1.414 2 2 1.414-1.414-2-2zM13 14h-2v2h2zm-2 0H9v2h2zm1 1v-2h-2v2zm-2 0v2h2v-2zm13 5h-4v2h4zm0 4h-4v2h4zm0-10h-4v2h4z"
      />
    </svg>
  );
};
SvgCalculatorAlt.displayName = displayName;
export default SvgCalculatorAlt;
